var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-loading-block"},[_c('div',{staticClass:"animated-background",style:('height:' + _vm.defaultHeight)})])}
var staticRenderFns = []

export { render, staticRenderFns }